export const PRICE_OVERRIDE_BY_CUSTOMER_LOAD = 'PRICE_OVERRIDE_BY_CUSTOMER_LOAD';
export const PRICE_OVERRIDE_BY_CUSTOMER_LOADED = 'PRICE_OVERRIDE_BY_CUSTOMER_LOADED';
export const PRICE_OVERRIDE_UNLOAD = 'PRICE_OVERRIDE_UNLOAD';
export const PRICE_OVERRIDE_UPDATE = 'PRICE_OVERRIDE_UPDATE';
export const PRICE_OVERRIDE_UPDATE_SUCCESS = 'PRICE_OVERRIDE_UPDATE_SUCCESS';
export const PRICE_OVERRIDE_DELETE = 'PRICE_OVERRIDE_DELETE';
export const PRICE_OVERRIDE_DELETE_SUCCESS = 'PRICE_OVERRIDE_DELETE_SUCCESS';
export const PRICE_OVERRIDE_LOAD = 'PRICE_OVERRIDE_LOAD';
export const PRICE_OVERRIDE_LOADED = 'PRICE_OVERRIDE_LOADED';
